export default __webpack_public_path__ + "static/media/excalibur_new_york_new_york.0f316d37.jpeg";